import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { OrganizationContact, OrganizationContactPayload } from '@/organization/organization/organization.model';

@Injectable({
	providedIn: 'root',
})
export class OrganizationContactsApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getContacts(organizationId: number): Observable<OrganizationContact[]> {
		return this.httpClient.get<OrganizationContact[]>(this.contactsUrl(organizationId));
	}

	createContact(organizationId: number, payload: OrganizationContactPayload): Observable<OrganizationContact> {
		return this.httpClient.post<OrganizationContact>(this.contactsUrl(organizationId), payload);
	}

	updateContact(
		organizationId: number,
		contactId: number,
		payload: OrganizationContactPayload,
	): Observable<OrganizationContact> {
		return this.httpClient.patch<OrganizationContact>(`${this.contactsUrl(organizationId)}${contactId}/`, payload);
	}

	deleteContact(organizationId: number, contactId: number): Observable<void> {
		return this.httpClient.delete<void>(`${this.contactsUrl(organizationId)}${contactId}/`);
	}

	private contactsUrl(organizationId: number): string {
		return `${this.apiUrl}/organization/${organizationId}/contact/`;
	}
}
